import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction, Value } from "@mcurros2/microm";
import { ClientesProductos } from "../ClientesProductos/ClientesProductos";
import { ClientesTiendasProductos } from "../ClientesTiendasProductos/ClientesTiendasProductos";


export const ACTQuitarProductos: EntityClientAction = {
    name: 'ACTQuitarProductos',
    label: 'Quitar productos',
    title: <Text fw={700}>Quitar productos</Text>,
    refreshOnClose: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as ClientesTiendasProductos;
        const productos = new ClientesProductos(entity.API.client);
        productos.parentKeys = parent.parentKeys;

        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Quitar productos</Text>,
                    size: 'xl'
                },
                focusOnClosed: element,
                content: <LookupFormAction
                    lookupEntity={productos}
                    viewName={productos.def.views.clpr_brwStandard.name}
                    title="Quitar productos seleccionados"
                    confirmContent="¿Está seguro de que desea Quitar los productos seleccionados a las tiendas seleccionadas?"
                    onActionFinished={async () => { if (onClose) await onClose() }}
                    onOK={
                        async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                            if (selectedKeys && selectedKeys.length > 0) {
                                const clientes_tiendas_productos = new ClientesTiendasProductos(entity.API.client, entity.parentKeys);

                                const parentKeys: Record<string, Value> = {};
                                parentKeys[clientes_tiendas_productos.def.columns.c_cliente_id.name] = parent.parentKeys[clientes_tiendas_productos.def.columns.c_cliente_id.name];

                                for (const key of selectedKeys) {
                                    parentKeys[clientes_tiendas_productos.def.columns.c_tienda_id.name] = key[clientes_tiendas_productos.def.columns.c_tienda_id.name];

                                    await clientes_tiendas_productos.API.deleteData(keys, abortSignal, parentKeys);
                                }

                            }
                            return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                        }
                    }
                />

            });
        }
        else {
            console.log('modal context not found');
        }

        return Promise.resolve(false);


    }

}

